import { atom } from 'jotai'
import type { Map } from 'mapbox-gl'
import type { MutableRefObject } from 'react'

export type PropertyMapPadding = {
  top: number
  right: number
  bottom: number
  left: number
}

export const propertyMapInstanceAtom = atom<Map | null>(null)

export const propertyMapPaddingRefAtom = atom<MutableRefObject<PropertyMapPadding>>({
  current: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
})
